//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/DumpResult.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/DumpResult.proto.
 */
export const file_android_hardware_automotive_vehicle_DumpResult: GenFile = /*@__PURE__*/
  fileDesc("CjRhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9EdW1wUmVzdWx0LnByb3RvEilhbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90byJgCgpEdW1wUmVzdWx0EiAKGGNhbGxlcl9zaG91bGRfZHVtcF9zdGF0ZRgBIAEoCBIOCgZidWZmZXIYAiABKAkSIAoYcmVmcmVzaF9wcm9wZXJ0eV9jb25maWdzGAMgASgIYgZwcm90bzM");

/**
 * @generated from message android.hardware.automotive.vehicle.proto.DumpResult
 */
export type DumpResult = Message<"android.hardware.automotive.vehicle.proto.DumpResult"> & {
  /**
   * If callerShouldDumpState is true, caller would print the information in buffer and
   * continue to dump its state, otherwise would just dump the buffer and skip its own
   * dumping logic. 
   *
   * @generated from field: bool caller_should_dump_state = 1;
   */
  callerShouldDumpState: boolean;

  /**
   * The dumped information for the caller to print. 
   *
   * @generated from field: string buffer = 2;
   */
  buffer: string;

  /**
   * To pass if DefaultVehicleHal should refresh the property configs. 
   *
   * @generated from field: bool refresh_property_configs = 3;
   */
  refreshPropertyConfigs: boolean;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.DumpResult.
 * Use `create(DumpResultSchema)` to create a new message.
 */
export const DumpResultSchema: GenMessage<DumpResult> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_DumpResult, 0);

